import React from "react";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";

export interface IDayWindowData {
    enabled: boolean;
    start_time: string;
    end_time: string;
    is_hard: boolean;
    soft_penalty_per_hour?: number;
}

type Props = {
    dayName: string;
    dayLabel: string;
    data: IDayWindowData;
    onChange: (dayName: string, field: keyof IDayWindowData, value: any) => void;
};

const constraintOptions = [
    { value: "hard", label: "Hard" },
    { value: "soft", label: "Soft" },
];

export const DayWindowRow = (props: Props) => {
    const { dayName, dayLabel, data, onChange } = props;

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(dayName, "enabled", e.target.value === "true");
    };

    const handleTimeChange = (field: "start_time" | "end_time") => (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(dayName, field, e.target.value);
    };

    const handleConstraintChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(dayName, "is_hard", e.target.value === "hard");
    };

    const handlePenaltyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value === "" ? undefined : parseFloat(e.target.value);
        onChange(dayName, "soft_penalty_per_hour", value);
    };

    return (
        <div className="day-window-row d-flex align-items-center mb-2">
            <div className="day-checkbox" style={{ width: "90px" }}>
                <OwCheckbox
                    label={dayLabel}
                    name={`${dayName}_enabled`}
                    checked={data.enabled}
                    fn={handleCheckboxChange}
                    truthyVal={"true"}
                    falsyVal={"false"}
                />
            </div>

            <div className="day-times d-flex align-items-center ms-2">
                <input
                    type="time"
                    className="form-control form-control-sm"
                    style={{ width: "110px" }}
                    value={data.start_time}
                    onChange={handleTimeChange("start_time")}
                    disabled={!data.enabled}
                />
                <span className="mx-2">-</span>
                <input
                    type="time"
                    className="form-control form-control-sm"
                    style={{ width: "110px" }}
                    value={data.end_time}
                    onChange={handleTimeChange("end_time")}
                    disabled={!data.enabled}
                />
            </div>

            <div className="day-constraint ms-2">
                <OwSelectOption
                    name={`${dayName}_constraint`}
                    options={constraintOptions}
                    valueProp="value"
                    titleProp="label"
                    selectedOption={{ constraint: data.is_hard ? "hard" : "soft" }}
                    selectedOptionProp="constraint"
                    fn={handleConstraintChange}
                    isDisabled={!data.enabled}
                    sizeClass="form-control-sm"
                />
            </div>

            {!data.is_hard && data.enabled && (
                <div className="day-penalty ms-2 d-flex align-items-center">
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        value={data.soft_penalty_per_hour ?? ""}
                        onChange={handlePenaltyChange}
                        placeholder="Priority"
                        min="0"
                        step="1"
                    />
                </div>
            )}
        </div>
    );
};

export default DayWindowRow;
